import React from 'react';
import { Link } from 'react-router-dom';
import { APPLY_ROUTE, LOGIN_ROUTE, withBase } from '../../publicSite/config';

export default function Footer() {
  return (
    <footer className="ps-footer">
      <div className="ps-footer-inner">
        <div className="ps-footer-brand">
          <div className="ps-footer-logo">
            <img src="/logos/shem_logo_transparent.png" alt="" />
            <h3>School of SHEM</h3>
          </div>
          <p>Structured, faith-aligned learning that equips families, leaders, and builders for Kingdom impact.</p>
          <p>2 Selbourne Rd, Fourways, Block 808 Hammets Crossing Office Park, Johannesburg, South Africa</p>
        </div>
        <div>
          <h4>Explore</h4>
          <Link to={withBase('/about')}>About</Link>
          <Link to={withBase('/academics/faculties')}>Academics</Link>
          <Link to={withBase('/admissions')}>Admissions</Link>
          <Link to={withBase('/events')}>Events</Link>
        </div>
        <div>
          <h4>Get started</h4>
          <Link to={withBase(APPLY_ROUTE)}>Apply</Link>
          <Link to={withBase('/admissions/enquire')}>Make an enquiry</Link>
          <Link to={withBase('/admissions/faqs')}>Admissions FAQs</Link>
          <Link to={withBase(LOGIN_ROUTE)}>Sign in</Link>
        </div>
        <div>
          <h4>Contact</h4>
          <a href="mailto:info@schoolofshem.com">info@schoolofshem.com</a>
          <a href="tel:+27615871145">+27 61 587 1145</a>
          <a href="https://www.instagram.com/schoolofshem/" target="_blank" rel="noreferrer">Instagram</a>
          <a href="https://www.facebook.com/share/1Hu5cAPnYT" target="_blank" rel="noreferrer">Facebook</a>
          <a href="https://www.youtube.com/@TichTanyanyiwa" target="_blank" rel="noreferrer">YouTube</a>
        </div>
      </div>
      <div className="ps-footer-bottom">
        <span>© 2026 School of Shem. All rights reserved.</span>
        <span>Johannesburg · South Africa</span>
      </div>
    </footer>
  );
}
